import { COLOR_PALETTE, Stack, Text, Title } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

export const PartnersSignupHeader = () => {
  const { t } = useTranslation();
  return (
    <Stack
      spacing={8}
      align="center"
      pt={16}
      pb={24}
      css={{
        borderBottom: `1px solid ${COLOR_PALETTE.gray[3]}`,
      }}
    >
      <Title order={1} size="h2">
        {t('인프런 마케팅 파트너스 가입')}
      </Title>
      <Text size="sm">{t('가입을 위한 정보를 입력해 주세요.')}</Text>
    </Stack>
  );
};
